import {Link, withRouter} from "react-router-dom";
import { useRef,useEffect } from "react";
import styled from "styled-components";
import {TweenMax, TimelineLite, gsap } from "gsap";

const Header = styled.header`
background: rgba(20,20,20,0.5);
backdrop-filter: blur(6px);
    width: 100%;
    height: 60px;
    display:flex;
    align-items: center;
    
    position: fixed;
    top: 0;
    left:0;
    box-shadow: 0px 1px 5px 2px rgba(0,0,0,0.8);
    z-index: 1;
    `;
    

const Logo = styled(Link)`
    font-family: 'Style Script', cursive;
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    font-size: 30px;
    font-weight: 600;
    color: rgba(230, 0, 0, 1);
`;



const Ul = styled.ul`
    display: flex;
    justify-content :center;
    width:100%;
    height:100%;    
`;

const Item = styled.li`
    font-size: 17px;
    color: rgba(255,255,255,0.8);
    list-style: none;
    text-align: center;
    display: flex;
    border-bottom: 5px solid ${props => props.current ? "rgba(230, 0, 0, 1)" : "transparent"};
    transition: 0.5s ease-in-out;
`;


const Slink = styled(Link)`
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: white;
    
`



export default withRouter(({location: {pathname}}) => {
    console.log(pathname);
    let test = useRef(null);
   
    
    // useEffect(() => {
    //     gsap.from(test, {x: 2000, duration: 2})

    // })

    return (
        <Header ref={el => test = el}>
            <Logo to="/">
                DAINFLIX
            </Logo>
            <Ul>
                <Item current={pathname === "/"}><Slink className="link" to="/">Home</Slink></Item>
                <Item current={pathname === "/tv"}><Slink className="link" to="/tv">TV</Slink></Item>
                <Item current={pathname === "/search"}><Slink className="link" to="/search">Search</Slink></Item>
            </Ul>
        </Header>
    )
}
);